export default "__VITE_ASSET__C8qou_E1__"